import React, { Component } from "react";
import PropTypes from "prop-types";
import "./index.css";
import { Icon } from "semantic-ui-react";
import { Link, push } from "redux-little-router";
import { connect } from "react-redux";
import {
  showPostModal as showPostModalAction,
  showUserSignInModal as showUserSignInModalAction,
} from "../../../../actions";
import { loadPostComments, loadSimilarPosts, loadCurrentPostByIdRequest } from "../../../../actions/postActions";
import InteractionsGroup from "../Interactions/components/InteractionsGroup";
import PostCardHeader from "../PostCardHeader";
import PostCardFooter from "../PostCardFooter";
import CaseActionsDropdownContainer from "../CaseActionsDropdownContainer";
import { isLoggedInUser } from "../../../../util/selectors";
import { constructUserProfilePath, constructPostSlugPath, checkIfDesktop } from "../../../../util/index";
import OptimizedImg from "../../../../components/OptimizedImg";
import OverlayIcon from "../../../OverlayIcon";
import RecentComment from "../RecentComment";

class Card extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedImageIndex: this.props.post.coverImageIndex,
    };
    this.post = this.props.post;
    this.postImages = this.post.images;
    this.previewImagesCount = 4;
    this.previewImages = this.getPreviewImages(this.postImages, this.previewImagesCount);

    this.setSelectedImage = this.setSelectedImage.bind(this);
    this.showModal = this.showModal.bind(this);
    this.viewPost = this.viewPost.bind(this);
    this.hasExtraImages = this.hasExtraImages.bind(this);
  }

  getPreviewImages(postImages, previewImagesCount) {
    const previewImages = [];
    for (let i = 0; i < postImages.length; i++) {
      if (previewImages.length === previewImagesCount) {
        break;
      }

      // Only include images in the preview thumbnails
      const image = postImages[i];
      if (!image.type || image.type === "image") {
        previewImages.push(i);
      }
    }
    return previewImages;
  }

  showModal(e) {
    if (e) {
      e.preventDefault();
    }
    if (!checkIfDesktop() || !this.props.authorized) {
      // 641 TODO: make sure of the screen width of tablets devices
      this.viewPost();
    } else {
      this.props.actions.showModal(this.props.post);
      this.props.actions.loadCurrentPostByIdRequest(this.props.post._id);
    }
  }

  setSelectedImage(index) {
    if (!this.props.authorized) {
      this.props.actions.showUserSignInModal();
    } else if (index < this.postImages.length) {
      this.setState(prevState => ({
        ...prevState,
        selectedImageIndex: index,
      }));
    }
  }

  viewPost() {
    const postPath = constructPostSlugPath(this.props.post);
    this.props.actions.push(postPath);
  }

  hasExtraImages() {
    return this.postImages.length > this.previewImagesCount;
  }

  drawThumbnails() {
    if (this.postImages.length > 1) {
      return (
        <div className="-card-slides">
          {this.previewImages.map((imageIndex, i) => (
            <OptimizedImg
              url={this.postImages[imageIndex] && this.postImages[imageIndex].src}
              alt=""
              key={i}
              size="xs"
              className="-slide-img"
              onClick={() => this.setSelectedImage(imageIndex)}
            />
          ))}
          {this.drawExtraImagesBox()}
        </div>
      );
    }
    return "";
  }

  drawExtraImagesBox() {
    if (this.hasExtraImages()) {
      return (
        <a onClick={this.showModal} className="-slide-img -img-counter">
          {`+${this.postImages.length - this.previewImagesCount}`}
        </a>
      );
    }
    return "";
  }

  render() {
    const { owner, title, description, category, caseType } = this.props.post;
    const selectedImageIndex = this.state.selectedImageIndex;
    const selectedImage = this.postImages[selectedImageIndex];
    const profilePath = constructUserProfilePath(owner);
    const postPath = constructPostSlugPath(this.props.post);
    return (
      <article className={`card -post ${this.props.animationClass}`}>
        <PostCardHeader owner={owner} profilePath={profilePath}>
          <CaseActionsDropdownContainer post={this.props.post} />
        </PostCardHeader>
        <div className="-card-slider">
          <Link href={postPath} onClick={this.showModal}>
            {selectedImage && selectedImage.type === "video" ? (
              <div>
                <OverlayIcon size="huge" name="film" />
                <video src={selectedImage.src} preload="metadata" className="-single-img -single-video" />
              </div>
            ) : (
              <OptimizedImg url={selectedImage && selectedImage.src} alt="" size="l" className="-single-img" />
            )}
          </Link>
          <div className="-imgs-counter">
            <Icon inverted name="image" color="grey" />
            <span className="-counter-number">{this.postImages.length}</span>
          </div>
          {this.drawThumbnails()}
        </div>
        <PostCardFooter
          title={title}
          description={description}
          category={category}
          caseType={caseType}
          onClick={this.showModal}
        />
        <InteractionsGroup post={this.props.post} viewPost={this.showModal} />
        <RecentComment viewPost={this.showModal} recentComment={this.props.post.latestComment} />
      </article>
    );
  }
}

Card.propTypes = {
  post: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const authorized = isLoggedInUser(state);
  return {
    authorized,
    currentRoute: state.router,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      push: (...props) => dispatch(push(...props)),
      showModal: post => dispatch(showPostModalAction(post)),
      showUserSignInModal: () => dispatch(showUserSignInModalAction()),
      loadPostComments: postId => dispatch(loadPostComments(postId)),
      loadSimilarPosts: postId => dispatch(loadSimilarPosts(postId)),
      loadCurrentPostByIdRequest: postId => dispatch(loadCurrentPostByIdRequest(postId)),
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Card);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/PostCard/index.js